(function () {
  'use strict';

  angular
    .module('itecAdministracio')
    .config(config);

  function config($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.when('', '/usuaris');
    $urlRouterProvider.otherwise('/');

    $stateProvider
    .state('pagenotfound', {
      url: '/',
      views: {
        'wrapper': {
          template: '<itec-notfound initial-state="usuaris"></itec-notfound>',
        }
      },
    });
  }
}());
